import React, { FC } from "react"
import { EventResponse } from "@jnext/ts-axios-eventformat"
import { JSlider } from "../../JSlider"
import { SLIDER_3X } from "../../configs"
import { JCardEvent } from "../../../JCMSCard/components/JCardEvent/JCardEvent"

export interface JSliderEventProps {
    events: EventResponse[]
}
export const JSliderEvent: FC<JSliderEventProps> = ({ events }) => {
    
    return (
        <JSlider {...SLIDER_3X}>
            {
                events.map((event, i) => (
                    <JCardEvent {...event} key={i} />
                ))
            }
        </JSlider>
    )
}

